import React from 'react';
import { useState, useContext, useEffect } from 'react';
import { Container, Modal, ModalHeader, Input, Row, Button, Table, Badge, Spinner, Collapse, Card, CardHeader, CardBody, InputGroup } from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'
import { AppContext } from './AppContext';
import { TiPlus } from 'react-icons/ti';
import { IoIosTrash, IoMdCreate } from 'react-icons/io';
import { BiArchiveIn } from 'react-icons/bi';

export const Rubricas = (props) => {
    const edoGlobal = useContext(AppContext);
    let [id, setId] = useState(0);
    let [indice, setIndice] = useState(0);
    let [capturando, setCapturando] = useState(false);
    let [rubricas, setRubricas] = useState([]);
    let [cargando, setCargando] = useState(false);
    let [texto, setTexto] = useState("");
    let [urlArchivo, setUrlArchivo] = useState("");
    let [conArchivo,setConArchivo] = useState(false);
    
    useEffect(() => {
        (async () => {
            cargarDatos();
        })();
    }, []);

    async function cargarDatos() {
        setCapturando(false);
        setCargando(true);
        let url = `${edoGlobal.urlws}/programaIndicativo/rubricas`;
        let resp = await fetch(url);
        const m = await resp.json();
        setCargando(false);
        setRubricas(m);
    }
    function nuevo(){
        setId(0);
        setTexto("");
        setUrlArchivo("");
        setConArchivo(false);
        setCapturando(true);
    }
    function descargar(i){
        let url = `https://paal.uadeo.mx/documento/descargarRubrica/${rubricas[i].Id}`;
        window.open(url, '', '');    
    }
    function editar(i){
        id = rubricas[i].Id;
        setIndice(i);
        setId(rubricas[i].Id);
        setTexto(rubricas[i].Texto);
        setConArchivo(rubricas[i].ConArchivo);
        setUrlArchivo("");
        setCapturando(true);
    }
    async function guardar() {
        const dato = {
            Id: id, Texto: texto,
            Usuario: edoGlobal.usuario.Id
        }
        let url = `${edoGlobal.urlws}/programaIndicativo/wsGuardarRubrica`;
        setCargando(true);
        const json = JSON.stringify(dato);
        const resp = await fetch(url, {
            method: 'POST', // or 'PUT'
            body: json // data can be `string` or {object}!
        });
        const res = await resp.text();
        setCargando(false);
        if (res === "ok") {
            cargarDatos();
        }
        else
            Swal.fire('Atencion', res, 'error');
    }
    async function eliminar(o) {
        const MySwal = withReactContent(Swal)
        MySwal.fire({
            title: 'Confirme',
            text: '¿ Desea eliminar "' + o.Texto + '" ?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#1c4c01',
            cancelButtonColor: 'maroon',
            cancelButtonText: 'No',
            confirmButtonText: 'Si'
        }).then((result) => {
            if (result.value)
                eliminarB(o.Id);
        });
    }
    async function eliminarB(i) {
        let url = `${edoGlobal.urlws}/programaIndicativo/eliminarRubrica/${i}`;
        setCargando(true);
        const resp = await fetch(url);
        const res = await resp.text();
        setCargando(false);
        if (res === "ok")
            cargarDatos();
        else
            Swal.fire('Atencion', res, 'error');
    }
    async function subir() {
        const { value: file } = await Swal.fire({
            title: 'Subir archivo',
            input: 'file',
            inputAttributes: {
                accept: '*/*',
                'aria-label': 'Seleccione archivo'
            }
        });

        if (file) {
            setCargando(true);
            const data = new FormData()
            data.append('file', file);
            data.append('id', id);
            let url = `${edoGlobal.urlws}/documento/subirRubrica`;
            const resp = await fetch(url, {
                method: 'POST', // or 'PUT'
                body: data // data can be `string` or {object}!
            });
            const res = await resp.text();
            setCargando(false);
            if (res == "ok") {
                rubricas[indice].ConArchivo = true;
                mostrarArchivo();
            }
            else
                Swal.fire('Atencion', res, 'success');
        }
    }    
    function mostrarArchivo(){
        //let url = `https://paal.uadeo.mx/content/documentos/rubricas/${id}.pdf`;
        let url = `https://paal.uadeo.mx/documento/descargarRubrica/${id}`;
        setUrlArchivo(url);
        console.log(url);
    }
    const estiloTabla = { display: capturando ? 'none' : 'inline' };
    const estiloForm = { display: capturando ? 'inline' : 'none' };

    return (
        <div>
            {cargando ?
                <div className="loader">
                    <Spinner animation="border" className='rojo' >&nbsp;</Spinner>
                </div>
                :
                null
            }
            <div style={estiloTabla}>
                <Table size="sm" hover striped>
                    <thead>
                        <th><h4><Badge color='maroon' style={{ color:'white', backgroundColor:'maroon' }} >Rúbricas  <Badge color='white' size="sm" ><span style={{color:'maroon'}}>{rubricas.length}</span></Badge> </Badge>  <span>&nbsp;&nbsp;&nbsp;</span><Button style={{ borderColor: 'maroon' }} size="sm" color="secondary" outline onClick={nuevo}><TiPlus size={20} color='maroon' title="nueva rúbricas" /><span className='negro'> Agregar rúbrica</span></Button></h4></th>
                        <th className='celdaBoton'>PDF</th>
                        <th className='celdaBoton'></th>
                        <th className='celdaBoton'></th>
                    </thead>
                    <tbody>
                        {rubricas.map((o, i) =>
                            <tr key={i}>
                                <td onClick={() => editar(i)}>{o.Texto}</td>
                                <td>
                                    {o.ConArchivo && <BiArchiveIn size={20} color='maroon' title='descargar archivo' onClick={() => descargar(i)} /> }
                                </td>
                                <td>
                                    <IoMdCreate size={20} color='maroon' title='editar' onClick={() => editar(i)}/>
                                </td>
                                <td>
                                    <IoIosTrash size={20} color='maroon' title='eliminar' onClick={() => eliminar(o)}/>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
            <div style={estiloForm}>
                <Row>
                    <div className='col'>
                        <span>Descripción </span>
                        <Input type="textarea" size="sm" value={texto}  onChange={(e)=>setTexto(e.target.value)} />
                    </div>
                </Row>
                <br/>
                <Row>
                    <div className='col-3'>
                    {conArchivo && <Button style={{ borderColor: 'maroon' }} size="sm" color="secondary" outline onClick={mostrarArchivo}>Ver archivo</Button>}
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    {id > 0 && <Button style={{ borderColor: 'maroon' }} size="sm" color="secondary" outline onClick={subir}>Subir archivo</Button>}
                    </div>
                    <div className='col'>
                        <Button style={{ borderColor: 'maroon' }} size="sm" color="secondary" outline title="guardar" onClick={guardar}> Guardar</Button>
                        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <Button style={{ borderColor: 'maroon' }} size="sm" color="secondary" outline title="cancelar" onClick={() => setCapturando(false)}> Cancelar</Button>
                    </div>
                </Row>
                <br/>
                {urlArchivo != "" && <iframe style={{width:'100%', height:600}} src={urlArchivo}></iframe> }
            </div>
        </div>
    )
}